import React from 'react';
import Select from 'react-select';
import EntityContractPhaseManager from '../longTermSchedule/EntityContractPhaseManager';
import JobResourceMultiSelect from './JobResourceMultiSelect';
import ResourceApplicationUserGroupMultiSelect from './ResourceApplicationUserGroupMultiSelect';
import moment from 'moment';

export default class DayDetailsPanel extends React.Component {
    getWeekJobResource = (weekOfDate) => {
        const { job } = this.props;

        return job.weekJobResources.find((wjr) =>
            moment(wjr.weekOfDate).isSame(weekOfDate, 'day')
        );
    };

    getOrCreateJobOverride = (weekResourceData, weekJobResource) => {
        const { overrideDate } = weekResourceData;

        return (
            weekJobResource.jobOverrides.find((jo) =>
                moment(jo.overrideDate).isSame(overrideDate, 'day')
            ) || { overrideDate }
        );
    };

    updateJobOverride = (weekJobResource, jobOverride) => {
        weekJobResource.jobOverrides = weekJobResource.jobOverrides.filter(
            (jo) =>
                !moment(jo.overrideDate).isSame(jobOverride.overrideDate, 'day')
        );

        weekJobResource.jobOverrides.push(jobOverride);
    };

    onChangeJobContractPhase = (supplementalData, entityContractPhaseState) => {
        const { dayOfWeek, weekOfDate } = supplementalData;
        const { job, jobResourcesValid, onJobUpdated } = this.props;
        const { isValid } = entityContractPhaseState;
        let { entityContractPhases } = entityContractPhaseState;

        entityContractPhases = entityContractPhases.map((ecp) => ({
            ...ecp,
            dayOfWeek,
        }));

        job.weekJobResources.forEach((wjr) => {
            if (wjr.weekOfDate != weekOfDate) {
                return;
            }

            wjr.jobContractPhases = wjr.jobContractPhases
                .filter((jcp) => jcp.dayOfWeek != dayOfWeek)
                .concat(entityContractPhases || []);
        });

        onJobUpdated(job, jobResourcesValid, isValid);
    };

    onManagedJobResourceCountChange = (
        supplementalData,
        managedJobResourceState
    ) => {
        const { weekOfDate, dayOfWeek } = supplementalData;
        const { managedJobResources, isValid } = managedJobResourceState;
        const { job, onJobUpdated } = this.props;

        job.weekJobResources.forEach((wjr) => {
            if (wjr.weekOfDate != weekOfDate) {
                return;
            }

            wjr.jobResources.forEach((jr) => {
                const managedJobResource = managedJobResources.find(
                    (mjr) => mjr.equipmentTypeId == jr.equipmentTypeId
                );

                if (!managedJobResource) {
                    return;
                }

                jr[dayOfWeek] = managedJobResource[dayOfWeek];
            });
        });

        onJobUpdated(job, isValid);
    };

    onManagedApplicationUserGroupResourceCountChange = (
        supplementalData,
        managedJobResourceState
    ) => {
        const { weekOfDate } = supplementalData;
        const { managedJobResources, isValid, dayName } =
            managedJobResourceState;
        const { job, onJobUpdated } = this.props;

        job.weekJobResources.forEach((wjr) => {
            if (wjr.weekOfDate != weekOfDate) {
                return;
            }

            wjr.jobResources.forEach((jr) => {
                const managedJobResource = managedJobResources.find(
                    (mjr) =>
                        mjr.applicationUserGroupId == jr.applicationUserGroupId
                );

                if (!managedJobResource) {
                    return;
                }

                jr[dayName] = managedJobResource[dayName];
            });
        });

        onJobUpdated(job, isValid);
    };

    onChangeLongTermJobOverrideRoadName = (weekResourceData, event) => {
        const { job, onJobUpdated } = this.props;
        const weekJobResource = this.getWeekJobResource(
            weekResourceData.weekOfDate
        );
        const jobOverride = this.getOrCreateJobOverride(
            weekResourceData,
            weekJobResource
        );

        jobOverride.roadName = event.target.value;

        this.updateJobOverride(weekJobResource, jobOverride);

        onJobUpdated(job);
    };

    onChangeJobOverrideArcGisLocation = (weekResourceData, arcGisLocation) => {
        const { job, onJobUpdated } = this.props;
        const weekJobResource = this.getWeekJobResource(
            weekResourceData.weekOfDate
        );
        const jobOverride = this.getOrCreateJobOverride(
            weekResourceData,
            weekJobResource
        );

        jobOverride.arcGisLocationId = arcGisLocation.id;

        this.updateJobOverride(weekJobResource, jobOverride);

        onJobUpdated(job);
    };

    render() {
        const {
            wjrKey,
            weekOfDate,
            dayOfWeek,
            dayName,
            dayOfDate,
            i,
            relevantJobContractPhases,
            jobOverrides,
            jobOverride,
            contractPhases,
            applicationUserGroups,
            longTermSchedule,
            equipmentTypes,
            arcGisLocations,
            jobResources,
            lowboyResources,
            equipmentTypeCounts,
            equipmentTypeIdsRequiringMoves,
            onManagedLowboyResourceChange,
            signalChange,
            anyLocationsDefined,
            locationPlaceholder,
            edit,
            disabled,
            job,
        } = this.props;

        const phaseEntityId = `phases${dayName}${wjrKey}-${i}`;
        const locationRequired =
            Boolean(anyLocationsDefined) && !longTermSchedule.arcGisLocationId;
        const locationMissing =
            locationRequired && !jobOverride.arcGisLocationId;

        return (
            <div className="border rounded p-2 bg-light h-100 day-details-panel">
                <div className="font-weight-bold mb-2">Additional Details</div>

                <div className="mb-3" key={phaseEntityId}>
                    <div className="small text-uppercase text-muted mb-1">
                        Phases
                    </div>
                    <EntityContractPhaseManager
                        contractPhases={contractPhases}
                        entityContractPhases={relevantJobContractPhases}
                        onEntityContractPhaseChange={this.onChangeJobContractPhase.bind(
                            this,
                            { weekOfDate, dayOfWeek }
                        )}
                        entityId={phaseEntityId}
                        existingEntityContractPhases={
                            longTermSchedule.longTermScheduleContractPhases
                        }
                        disabled={disabled}
                    />
                </div>

                <div className="mb-3">
                    <div className="small text-uppercase text-muted mb-1">
                        Labor Resources
                    </div>
                    <ResourceApplicationUserGroupMultiSelect
                        key={`raugms${dayName}${wjrKey}-${i}`}
                        applicationUserGroups={applicationUserGroups}
                        jobResources={jobResources}
                        dayName={dayName}
                        onManagedJobResourceCountChange={this.onManagedApplicationUserGroupResourceCountChange.bind(
                            this,
                            { weekOfDate, dayOfWeek }
                        )}
                        readOnly={!edit.allowResources || disabled}
                        {...this.props}
                    />
                </div>

                <div className="mb-3">
                    <div className="small text-uppercase text-muted mb-1">
                        Equipment Types
                    </div>
                    <JobResourceMultiSelect
                        key={`jrms${dayName}${wjrKey}-${i}`}
                        equipmentTypes={equipmentTypes}
                        arcGisLocations={arcGisLocations}
                        jobResources={jobResources}
                        lowboyResources={lowboyResources}
                        onManagedJobResourceCountChange={this.onManagedJobResourceCountChange.bind(
                            this,
                            { weekOfDate, dayOfWeek }
                        )}
                        dayName={dayName}
                        dayOfDate={dayOfDate}
                        equipmentTypeCounts={equipmentTypeCounts}
                        equipmentTypeIdsRequiringMoves={
                            equipmentTypeIdsRequiringMoves
                        }
                        onManagedLowboyResourceChange={
                            onManagedLowboyResourceChange
                        }
                        signalChange={signalChange}
                        disabled={disabled}
                        jobStartTime={job?.startTime}
                    />
                </div>

                <div>
                    <div className="small text-uppercase text-muted mb-1">
                        Location
                        {locationRequired && (
                            <span className="text-danger ml-1">*</span>
                        )}
                    </div>
                    {anyLocationsDefined && (
                        <Select
                            className="job-form-select-min"
                            classNamePrefix="react-select"
                            options={arcGisLocations}
                            getOptionValue={(agl) => agl.id}
                            getOptionLabel={(agl) => agl.addrLoc}
                            value={
                                arcGisLocations.filter(
                                    (agl) =>
                                        agl.id == jobOverride.arcGisLocationId
                                ) ?? ''
                            }
                            onChange={this.onChangeJobOverrideArcGisLocation.bind(
                                this,
                                {
                                    jobOverrides,
                                    weekOfDate,
                                    overrideDate: dayOfDate,
                                }
                            )}
                            readOnly={!edit.allowResources || disabled}
                            isDisabled={disabled}
                            placeholder={locationPlaceholder}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                                control: (base) =>
                                    locationMissing
                                        ? {
                                              ...base,
                                              borderColor: '#dc3545',
                                          }
                                        : base,
                            }}
                            menuPortalTarget={
                                typeof document !== 'undefined'
                                    ? document.body
                                    : null
                            }
                            menuPosition="fixed"
                        />
                    )}

                    {locationMissing && (
                        <div className="small text-danger mt-1">
                            Please select a location.
                        </div>
                    )}

                    {!anyLocationsDefined && (
                        <input
                            id={`roadName${dayName}${wjrKey}`}
                            className="w-100"
                            value={jobOverride.roadName}
                            data={{ weekOfDate }}
                            placeholder={longTermSchedule.roadName}
                            onChange={this.onChangeLongTermJobOverrideRoadName.bind(
                                this,
                                {
                                    jobOverrides,
                                    weekOfDate,
                                    overrideDate: dayOfDate,
                                }
                            )}
                            readOnly={!edit.allowResources || disabled}
                            disabled={disabled}
                        />
                    )}
                </div>
            </div>
        );
    }
}
